import React, { useState } from "react";

import { useQuery } from "react-query";
import { deletePages, getPages, updatePages } from "../../../MyApi/pages/index";



import i18next from "i18next";
import DataTable from "../../../Components/UI/table/DataTable";
import AddPageModal from "./AddPageModal";
import TableActions from "../../../Components/UI/table/TableActions";
import StatusBadge from "../../../Components/UI/statusBadge";


const TermsTab = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState("");

  const lang = i18next.language;

  const { data, isLoading, refetch } = useQuery(
    ["pages-data", lang],
    () => getPages(lang)
  );

 
  const pagesColumns = [
    {
      label: "عنوان الصفحة",
      render: (row) => (
        <div className="d-flex align-items-center gap-3">
          <div>
            <h6>{row.title}</h6>
            <p className="desc">{row.id}</p>
          </div>
        </div>
      ),
    },
    { 
      label: "الحالة", 
      render: (row) => (
        <div> 
          <StatusBadge status={row.is_active ? "active" : "inactive"} /> 
        </div>  
      ) 
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => openModal("edit", row.slug)}
          deleteFn={deletePages}
          refetch={refetch}
          mutationKey={"deletePages"}
          id={row.slug}
          editPermission="update_page"
          deletePermission="delete_page"
          togglePermission="update_page"
          toggleMutationKey={"toggle-update-page"}
          queryKey={"pages-data"}
          toggleFn={(id, status) => updatePages({is_active: status, "_method": "PUT", lang: i18next.language}, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

  const pagesData = data?.data?.pages || [];

  const openModal = (mode, id) => {
    setShowModal(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMode("add");
    setModalId("");
  };

  return (
    <div>
      <DataTable
        actionLabel="إضافة صفحة جديدة"
        createPermission="create_page"
        onAddClick={() => openModal("add")}
        title="السياسات وشروط الاستخدام"
        columns={pagesColumns}
        data={pagesData}
        isLoading={isLoading}
      />
      {showModal && (
        <AddPageModal
          show={showModal}
          onClose={closeModal}
          refetch={refetch}
          modalMode={modalMode}
          modalId={modalId}
        />
      )}
    </div>
  );
};

export default TermsTab;